import { Box, Typography, Link, Grid } from '@mui/material';
import './index.css';
import { EmailVerificationSuccess, LogoSuccessSvg, Congratulations } from '../../../assets/svg';
interface ICongratulationCard {
  message: string;
}

const CongratulationCard = ({ message }: ICongratulationCard) => {
  return (
    <Box className="congratulation-card--main-wrapper">
      <Grid className="congratulation-left-container">
        <Box className="congratulation-car-left-container-main">
          <Box className="congratulation-img-container" display={'flex'} mb={2.5}>
            <Congratulations />
          </Box>
          <Box className="congratulation-card--content-box">
            <Typography variant="h1" className="congratulation-card--title">
              Congratulations!
            </Typography>
            <Typography variant="body1" className="congratulation-card--body1">
              {message}
            </Typography>
            <Typography variant="subtitle1" className="congratulation-card--link-text">
              Please
              <Link href="/login" variant="subtitle1" className="congratulation-card--link">
                {' '}
                Log In{' '}
              </Link>{' '}
              Now
            </Typography>
          </Box>
        </Box>
      </Grid>
      <Grid className="congratulation-right-container">
        <EmailVerificationSuccess />
      </Grid>
    </Box>
  );
};

export default CongratulationCard;
